/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

export enum ESearchFilter {
  ALL = 'ALL',
  ON_TV = 'ON_TV',
  ON_DEMAND = 'ON_DEMAND',
  OPT_IN = 'OPT_IN',
}

export interface ISearchFilter {
  key: string;
  type: ESearchFilter;
  translationKey: string;
}
